import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme, StyleRulesCallback } from '../mui/styles';
import { Table, TableHead } from "../widget";
import { HeaderColumn, DataGridPadding, DataGridLines } from "./Types";

import DataGridHeaderRow from "./DataGridHeaderRow";


export interface DataGridHeaderProps {
    headerRows: HeaderColumn[][];
    headerRef: React.RefObject<HTMLDivElement>;
    width?: number;
    minWidth?: number;
    fixedHeight?: boolean;
    gridLines?: DataGridLines;
    padding?: DataGridPadding;
}


declare type Props = DataGridHeaderProps & WithStyles<typeof styles>;


class DataGridHeader extends React.PureComponent<Props> {

    render() {
        const { classes, fixedHeight, headerRef, padding, gridLines, headerRows } = this.props;

        let filterRow: boolean = (headerRows.length > 0) ? headerRows[headerRows.length - 1].some((e) => e.isFiltered) : false;

        const outerStyle: React.CSSProperties = {
            //            backgroundColor: 'aliceblue',
            //            color: 'red',
            // overflow: 'hidden' as 'hidden',
            paddingRight: fixedHeight ? 16 : 0
        }

        const innerStyle: React.CSSProperties = {
            overflow: 'hidden',
            borderRight: fixedHeight ? '1px solid rgba(224, 224, 224, 1)' : 'none',

        }

        /*
        const tableStyle: React.CSSProperties = {
            tableLayout: 'fixed',
            minWidth: this.props.minWidth ? this.props.minWidth : 'auto',
        }
*/
        //   console.log("HEAD: ", this.props);

        const rootClassName = classNames({
            [classes.root]: true,
            [classes.rootFixedHeight]: fixedHeight,
            [classes.bottomBorder]: !(gridLines === 'horizontal' || gridLines === 'both'),
        });

        const innerClassName = classNames({
            [classes.inner]: true,
            [classes.innerFixedHeight]: fixedHeight,
        })

        const tableClassName = classes.table;

        return <div className={rootClassName}>
            <div ref={headerRef} className={innerClassName}>
                <Table className={tableClassName}                >
                    <ColGroup headerRows={headerRows} />
                    <TableHead>
                        {headerRows.map((hrw, k) => <DataGridHeaderRow key={k} columns={hrw} padding={padding} gridLines={gridLines} />)}
                    </TableHead>
                </Table>
            </div>
        </div>;
    }
}


const styles = ((theme: Theme) => {

    return createStyles({

        root: {
            paddingRight: 0,
            borderBottom: '1px solid ' + theme.palette.divider,
        },

        bottomBorder: {
            //            borderBottom: '1px solid ' + theme.palette.divider,
        },

        rootFixedHeight: {
            paddingRight: 16,
        },

        fixedHeight: {
        },

        inner: {
            overflow: 'hidden',
            borderRight: 'none',
        },

        innerFixedHeight: {
            borderRight: '1px solid ' + theme.palette.divider,
        },

        table: {
            tableLayout: 'fixed',
            minWidth: 'auto',
        },

        padding: {
            height: 0,
        },

    })
}) as StyleRulesCallback;

export default withStyles(styles)(DataGridHeader);


interface ColGroupProps {
    headerRows: HeaderColumn[][];
}

export const ColGroup = (props: ColGroupProps) => {

    const cols: any[] = [];
    {
        props.headerRows.map((row) => {
            row.map((c) => {
                if (c.field !== undefined) {
                    cols[c.index] = <col key={c.field} style={{ width: c.width || 'auto' }} />;
                }
            });
        })
    }

    return <colgroup>
        {cols}
    </colgroup>;
}
